<template>
  <v-row justify="center">
    <v-col lg="4">
      <v-dialog
        v-model="dialogVisible"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="dialogHeaders"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'show', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.show="{item}">
                <v-checkbox v-model="item.show" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="onApply"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="onClose"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "HeaderDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogHeaders: {
      type: Array
    }
  },
  data: () => ({
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    headers: {},
  }),
  mounted () {
    this.headers = { entity: "attribute", headers: ["1", "2"] }
  },
  methods: {
    onApply () {
      console.log('this.dialogHeaders', this.dialogHeaders)
      this.$emit("header", this.dialogHeaders)
    },
    onClose () {
      this.$emit("close")
    }
  }
}
</script>

<style scoped>

</style>
